import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export function useAmazonAdsConnectionStatus() {
  const marketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const onboardData = useAppSelector((state) => state.amz_onboard);

  return useQuery({
    queryKey: ["amazonAdsConnectionStatus", marketplace],
    queryFn: async () =>
      await apiClient.getCurrentProfileAmazonAdsConnectionStatus({
        queries: { marketplace },
      }),
    enabled: channel === "amazon" && onboardData.amazon_advertising_access === "connected",
  });
}
